import React from 'react';
import { LoadingInlineStyled } from './styles';

function LoadingInline({ loading }) {
  if (!loading) return null;

  return (
    <LoadingInlineStyled>
      <div className="lds-ring">
        <div />
        <div />
        <div />
        <div />
      </div>
    </LoadingInlineStyled>
  );
}

LoadingInline.defaultProps = {
  loading: false,
};

export default LoadingInline;
